import { render, staticRenderFns } from "./uninstall-v1.vue?vue&type=template&id=8883a074&scoped=true&"
import script from "./uninstall-v1.vue?vue&type=script&lang=js&"
export * from "./uninstall-v1.vue?vue&type=script&lang=js&"
import style0 from "./uninstall-v1.vue?vue&type=style&index=0&id=8883a074&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8883a074",
  null
  
)

export default component.exports